<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  created() {
    document.title = "Devlog";
  },
};
</script>

<style>
app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  background-color: #1a1b26;
  color: #c0caf5;
}
body {
  background-color: #1a1b26;
}
</style>
